import {
  loadIsPaymentPanelActionCompleteActive,
  loadIsSalePanelActive,
  loadIsMainLoading,
  loadIsDetailLoading,
  loadPreventSellRunnerExecution,
  loadIsRefundSale,
  loadFormLayoutName,
  loadIsPaymentPanelLoading,
  loadMainQuicKeyDetails,
  loadQuicKeyDetails,
  loadSaleOrderJson,
  loadAllQuicKeyDetails
} from './MainSale'
import {
  loadCurrentSalesOrderData,
  loadCustomerSearchData,
  loadRefundSaleStatus,
  loadTempSalesOrderData,
  loadSaleProgressModalShow,
  loadSalePaymentData,
  loadSellSelectedAttributes
} from './Sell'
import ds from '../../Services/DataServices'
import { message } from 'antd'
import {
  removeSpacewithLowerCaseString,
  getDecryptID,
  isEmptyObject,
  clearAllSale,
  saleIsInProgress,
  loadIncomingSale,
  setDiscCurrPerNote,
  updateExistingProds,
  updateExistingTaxes
} from './GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import {
  customParse,
  fetchCurrentSalesOrder,
  loadSaleProductJsonData,
  notAllowMsgCheck,
  updateSaleIndexed
} from '.'
import { saveEntitiesDatatoIndexBD } from './IndexDBActions'
import { CONFIG_LOGS } from '../../constants/IndexDB_Logs'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'

export function loadSalesOrderDataService (
  body,
  getCurrentSalesOrderData,
  getSalesOrderStatuses,
  getIsInProgress,
  isReturn
) {
  return dispatch => {
    getSalesOrderDataService(
      dispatch,
      body,
      getCurrentSalesOrderData,
      getSalesOrderStatuses,
      getIsInProgress,
      isReturn
    )
  }
}

export function loadPostMainSaleProductServices (
  body,
  getSalesOrderStatuses,
  getCurrentSalesOrderData,
  getIsPaymentPanelActionCompleteActive,
  loadNewSale,
  fromPayClick,
  isIgnoreCal,
  payData,
  sellSelectedAttribs,
  buildProds
) {
  return dispatch => {
    let methType = BEHAVIOUR_TYPE.GET
    // if (body.BehaviorName) {
    //   methType = body.BehaviorName == 1 ? BEHAVIOUR_TYPE.POST :
    //     body.BehaviorName == 3 ? BEHAVIOUR_TYPE.UPDATE : body.BehaviorName == 2 ? BEHAVIOUR_TYPE.DELETE : "";
    // }
    postMainSaleProductServices(
      dispatch,
      body,
      getSalesOrderStatuses,
      getCurrentSalesOrderData,
      getIsPaymentPanelActionCompleteActive,
      methType,
      loadNewSale,
      fromPayClick,
      isIgnoreCal,
      payData,
      sellSelectedAttribs,
      buildProds
    )
  }
}

export function loadPostMainSaleDeleteDataService (body) {
  return dispatch => {
    dispatch(loadIsMainLoading(true))
    postMainSaleDeleteDataService(body, dispatch)
  }
}

//salis
export function loadQuickLayoutData (body, isMounted, quickFolderActive) {
  return dispatch => {
    getQuickLayoutDataService(body, isMounted, dispatch, quickFolderActive)
  }
}

////

async function getSalesOrderDataService (
  dispatch,
  body,
  getCurrentSalesOrderData,
  getSalesOrderStatuses,
  getIsInProgress,
  isReturn
) {
  dispatch(loadIsDetailLoading(true))
  const getSalesOrderDataByID = ds.getSaleHistoryByIdService(
    body,
    BEHAVIOUR_TYPE.GET
  )
  await getSalesOrderDataByID
    .then(response => {
      dispatch(loadIsDetailLoading(false))
      if (response && response.length > 0) {
        //setting sell attributes
        let sellAttribs = []
        if (
          response[0].sellAttributes &&
          response[0].sellAttributes.length > 0
        ) {
          sellAttribs = response[0].sellAttributes
        }
        dispatch(loadSellSelectedAttributes(sellAttribs))
        //marking to identify that the prods coming first time from backend
        if (response[0].products && response[0].products.length > 0) {
          response[0].products.map(a => (a.firstTime = true))
        }
        //marking to identify its the return sale
        if (
          isReturn &&
          response[0].products &&
          response[0].products.length > 0
        ) {
          response[0].products.map(a => (a.isRefund = true))
        }
        let saleOrderData = response[0]
        let customer = {}
        dispatch(loadIsPaymentPanelLoading(false))
        // check if there is in progress sale
        if (!isEmptyObject(getCurrentSalesOrderData) && getIsInProgress) {
          if (body.isRefund != undefined && body.isRefund) {
            saleOrderData.isRefund = true
            saleOrderData.firstRefund = true
          }
          saleIsInProgress(dispatch, saleOrderData)
        } else {
          // for whole sale disc & note
          setDiscCurrPerNote(saleOrderData, dispatch)
          // for customer
          if (
            saleOrderData.customer &&
            saleOrderData.customer.length > 0 &&
            saleOrderData.customer[0].customerFirstName
          ) {
            customer = saleOrderData.customer[0]
            const firstLetter = customer.customerFirstName
              ? customer.customerFirstName.charAt(0)
              : 'x'
            const secondLetter = customer.customerLastName
              ? customer.customerLastName.charAt(0)
              : 'y'
            const lettersName =
              firstLetter.toUpperCase() + secondLetter.toUpperCase()
            customer.letterName = lettersName
          }
          if (body.isRefund != undefined && body.isRefund) {
            if (!isEmptyObject(saleOrderData)) {
              //yahan sale k response me msg code dekhenge ,, refund not allowed pr msg dekha denge , right now data k length dekhty hen agr data ajaye tw sale hy ,,waran sale nhi hy,, 3 msg rakhen ,,sale not exist, sale exist , sale exist but not allowed for refund
              // dispatch(loadRefundSaleStatus(1));
              if (false) {
                //!isEmptyObject(getCurrentSalesOrderData)
                // dispatch(loadSaleProgressModalShow(true));
                // dispatch(loadTempSalesOrderData(saleOrderData));
                // // setPreventSellRunnerExecution(false);
                // dispatch(loadPreventSellRunnerExecution(false));
              } else {
                // if (saleOrderData) {}
                saleOrderData.isRefund = true
                saleOrderData.firstRefund = true
                dispatch(loadPreventSellRunnerExecution(false))
                dispatch(loadIsRefundSale(true))
                dispatch(loadRefundSaleStatus(0))
                localStorage.setItem('parentOrderGuidID', saleOrderData.key)
                saleOrderData.e_ParentSalesOrderID = saleOrderData.key
                saleOrderData.key = ''
                saleOrderData.sSalesOrderStatusID = fetchCurrentSalesOrder('Return, In Progress') //return_inProgress
                dispatch(loadCurrentSalesOrderData(saleOrderData))
                // //dispatch(loadCurrentOrderGuidID(selectedParkedSaleData.key));
                // let statusID = getSalesOrderStatuses
                //   .filter(
                //     (x) =>
                //       removeSpacewithLowerCaseString(x.StatusName) == "return,completed"
                //   )
                //   .map((e) => {
                //     return e.SalesOrderStatuID;
                //   });
                // setCurrentSalesOrderStatusID(statusID);
                // setPreventSellRunnerExecution(false);
              }
            } else {
              dispatch(loadRefundSaleStatus(2))
            }
          } else {
            dispatch(loadPreventSellRunnerExecution(false))
            dispatch(loadCurrentSalesOrderData(saleOrderData))
          }

          if (customer && !isEmptyObject(customer)) {
            dispatch(loadCustomerSearchData(customer))
          }
        }
      } else {
        if (body.isRefund != undefined && body.isRefund) {
          dispatch(loadRefundSaleStatus(2))
          localStorage.setItem('orderGuidID', '')
          // setIsRefundSale(false);
          dispatch(loadIsRefundSale(false))
        }
      }
    })
    .catch(e => {
      notAllowMsgCheck(e)
    })
}

async function postMainSaleProductServices (
  dispatch,
  body,
  getSalesOrderStatuses,
  getCurrentSalesOrderData,
  getIsPaymentPanelActionCompleteActive, // false
  methodType,
  loadNewSale, // false
  fromPayClick, // true
  isIgnoreCal, // false
  payData,
  sellSelectedAttribs,
  buildProds
) {
  body.SellAttributes =
    sellSelectedAttribs && sellSelectedAttribs.length > 0
      ? sellSelectedAttribs
      : []
  if (body.SellAttributes && body.SellAttributes.length > 0) {
    body.SellAttributes.map(a => {
      if (typeof a.sellAttribID !== 'string') {
        a.sellAttribID = ''
      }
    })
  }
  const postSaleData = ds.postMainSaleProductData(body, methodType)
  await postSaleData
    .then(res => {
      dispatch(loadIsMainLoading(false))

      // // // main sale helper
      if (res && res.result) {
        if(res.lineItems && res.lineItems.length > 0){
          body.LineItems = res.lineItems
        }
        body.DI_COPY = parseInt(getDecryptID(res.result))
        postMainSaleHelperService(body)
      }

      if (!fromPayClick) {
        dispatch(loadIsPaymentPanelLoading(false))
      }

      if (res && res.receiptCode) {
        getCurrentSalesOrderData.receiptCode = res.receiptCode
        updateSaleIndexed(body.indexKey, { receipt_code: res.receiptCode })
      }

      if (!isIgnoreCal && res && res.result) {
        if (true) {
          const parkedStatusID =
            getDecryptID(body.E_SalesOrderStatusID) ==
            getDecryptID(fetchCurrentSalesOrder('Parked'))
          const parkedReturnStatusID =
            getDecryptID(body.E_SalesOrderStatusID) ==
            getDecryptID(fetchCurrentSalesOrder('Parked, return'))
          // for parked sale
          if (!fromPayClick && (parkedReturnStatusID || parkedStatusID)) {
            message.success('Sale Parked Successfully')
            // if (body && body.indexKey) {
            //   updateSaleIndexed(body.indexKey, { orderID: res.result })
            // }
            loadIncomingSale(loadNewSale, dispatch)
          } else if (getDecryptID(body.E_SalesOrderStatusID)) {
            if (!getIsPaymentPanelActionCompleteActive) {
              localStorage.setItem('orderGuidID', res.result)
              let salesOrderID = res.result
              getCurrentSalesOrderData.key = res.result
              let saleBody = {
                OutletID: '',
                SalesOrderID: salesOrderID,
                SalesOrderStatusID: '',
                CustomerID: '',
                UserID: '',
                CurrentPageNo: 1,
                PageSize: 10,
                isRefund: false
              }
              // // NOTE: OBSELETING AGAIN GET FROM SERVER
              // dispatch(
              //   loadSalesOrderDataService(
              //     saleBody,
              //     getCurrentSalesOrderData,
              //     getSalesOrderStatuses,
              //     false,
              //     false
              //   )
              // )
              dispatch(loadIsPaymentPanelLoading(false))
              // // // NOTE: Previously these things happened after getting the response from server but now we are not getting the response back from server
              // // // UPDATING PRODUCTS => For salesorderitems table
              updateExistingProds(
                res,
                getCurrentSalesOrderData,
                body,
                buildProds,
                salesOrderID
              )
              // // // UPDATING TAXES => For salesorderitemtaxes table
              updateExistingTaxes(
                res,
                getCurrentSalesOrderData,
                body,
                buildProds
              )
              dispatch(loadSaleProductJsonData(buildProds))
              dispatch(loadCurrentSalesOrderData(getCurrentSalesOrderData))
              body.E_SalesOrderID = res.result
              body.BehaviorName = 3 // for updated
              dispatch(loadSaleOrderJson(body))
              // NOTE: OBSELETING AGAIN GET FROM SERVER

              dispatch(loadIsMainLoading(false))
              let data = {}
              if (payData && !isEmptyObject(payData)) {
                payData.orderGuidID = res.result
                data = payData
              } else {
                data = {
                  orderGuidID: res.result,
                  amount: customParse(body.TotalPrice)
                }
              }
              dispatch(loadSalePaymentData(data))
            }
          }
        } else {
          dispatch(loadIsSalePanelActive(false))
          dispatch(loadIsDetailLoading(false))
          dispatch(loadIsPaymentPanelActionCompleteActive(false))
          message.error('Sale not Saved')
        }
      }
    })
    .catch(e => {
      notAllowMsgCheck(e)
      dispatch(loadIsPaymentPanelLoading(false))
      dispatch(loadIsMainLoading(false))
      dispatch(loadIsPaymentPanelLoading(false))
    })
}

async function postMainSaleHelperService (body) {
  const postSaleData = ds.postMainSaleHELPER(body, BEHAVIOUR_TYPE.GET)
  await postSaleData
    .then(res => {
      if (res) {
      }
    })
    .catch(e => {
      console.log(`helper burst ===> ${e}`)
      // notAllowMsgCheck(e)
    })
}

async function postMainSaleDeleteDataService (body, dispatch) {
  const postMainSaleDelete = ds.postMainSaleDeleteService(
    body,
    // BEHAVIOUR_TYPE.DELETE
    BEHAVIOUR_TYPE.GET
  )
  await postMainSaleDelete
    .then(response => {
      dispatch(loadIsMainLoading(false))
      clearAllSale(false, dispatch, false, true)
    })
    .catch(e => {
      dispatch(loadIsMainLoading(false))
      notAllowMsgCheck(e)
      clearAllSale(false, dispatch, false)
      // message.error("Something Went Wrong...");
    })
}

async function getQuickLayoutDataService (
  body,
  isMounted,
  dispatch,
  quickFolderActive
) {
  await ds
    .getQuickKeyLayouts(body, BEHAVIOUR_TYPE.GET)
    .then(quickKeyLayout => {
      if (isMounted) {
        if (
          quickKeyLayout != null &&
          Array.isArray(quickKeyLayout.data) &&
          quickKeyLayout.data.length != 0
        ) {
          let quickKeyFormData = quickKeyLayout.data
          if (quickKeyLayout.msgCode === 'GENERAL_SUCCESS') {
            // form.setFieldsValue({
            //   LayoutName: quickKeyFormData[0].layoutName,
            // });
            if (quickKeyFormData && quickKeyFormData.length > 0) {
              let layoutName = quickKeyFormData[0].layoutName
              dispatch(loadFormLayoutName(layoutName))
              let detailsBody = {
                QuickKeyLayoutID: quickKeyFormData[0].quicKKeyLayoutID
              }
              getQuickLayoutDetailsData(
                detailsBody,
                dispatch,
                quickFolderActive
              )
            }
          } else if (quickKeyLayout.msgCode === 'GENERAL_ERROR') {
            dispatch(loadIsDetailLoading(false))
          }
        } else {
          dispatch(loadMainQuicKeyDetails([]))
          dispatch(loadQuicKeyDetails([]))
          dispatch(loadIsDetailLoading(false))
        }
      }
    })
    .catch(e => {
      dispatch(loadIsDetailLoading(false))
    })
}

export async function getQuickLayoutDetailsData (
  body,
  dispatch,
  quickFolderActive
) {
  await ds
    .getQuickKeyLayoutDetails(body, BEHAVIOUR_TYPE.GET)
    .then(async quickKeyLayoutDetails => {
      if (
        quickKeyLayoutDetails != null &&
        Array.isArray(quickKeyLayoutDetails.data) &&
        quickKeyLayoutDetails.data.length != 0
      ) {
        let quickKeyFormData = quickKeyLayoutDetails.data
        
        if (quickKeyLayoutDetails.msgCode === 'GENERAL_SUCCESS') {
          // Here we can save data quick keys config
          dispatch(loadMainQuicKeyDetails(quickKeyFormData))
          if (!quickFolderActive) dispatch(loadQuicKeyDetails(quickKeyFormData))
          let index_body = {
            config_key: CONFIG_LOGS.QUICK_KEYS,
            data: JSON.stringify(quickKeyFormData)
          }
          await saveEntitiesDatatoIndexBD(
            [index_body],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.CONFIGDATA,
            'getQuickLayoutDetailsData'
          )

          dispatch(loadIsDetailLoading(false))
        } else if (quickKeyLayoutDetails.msgCode === 'GENERAL_ERROR') {
          dispatch(loadIsDetailLoading(false))
        }
      } else {
        dispatch(loadMainQuicKeyDetails([]))
        dispatch(loadQuicKeyDetails([]))
        dispatch(loadIsDetailLoading(false))
      }
    })
    .catch(e => {
      dispatch(loadIsDetailLoading(false))
    })
}

export async function getAllQuickLayoutDetailsData(dispatch) {
  await ds
    .getQuickKeyLayoutAllDetails(BEHAVIOUR_TYPE.GET)
    .then(async quickKeyLayoutDetails => {
      if (
        quickKeyLayoutDetails
      ) {
        let quickKeyFormData = quickKeyLayoutDetails.data;
        if (quickKeyLayoutDetails.msgCode === 'GENERAL_SUCCESS') {
 
          dispatch(loadAllQuicKeyDetails(quickKeyFormData))
           
          let index_body = {
            config_key: CONFIG_LOGS.ALL_QUICK_KEYS,
            data: JSON.stringify(quickKeyFormData)
          }

          await saveEntitiesDatatoIndexBD(
            [index_body],
            INDEX_DB_NAME,
            CURRENT_VERSION,
            INDEX_DB_TABLES.CONFIGDATA,
            'getAllQuickLayoutDetailsData'
          )
          dispatch(loadIsDetailLoading(false))
        } else if (quickKeyLayoutDetails.msgCode === 'GENERAL_ERROR') {
          dispatch(loadIsDetailLoading(false))
        }
      } else {
        dispatch(loadAllQuicKeyDetails([]))
        dispatch(loadIsDetailLoading(false))
      }
    })
    .catch(e => {
      dispatch(loadIsDetailLoading(false))
    })
}
